import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import GoldSiverHeader from '../../HomePage/GoldSiverHeader';
import { Row, Col, Form, Button } from 'react-bootstrap';
import axiosInstance from '../../../api/axios';
import { API_ENDPOINTS } from '../../../api/endpoint';
import { toast } from 'react-toastify';
import '../../../assets/css/pokemonMarket.css';
import './backpack.css';

function Backpack() {
    const { t, i18n } = useTranslation();
    const dispatch = useDispatch();
    const userData = useSelector(state => state.auth.user_data);
    const isRTL = i18n.language === 'he';
    const [activeTab, setActiveTab] = useState('pokemon_balls');
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const [sellingItems, setSellingItems] = useState({});
    const [sellAmounts, setSellAmounts] = useState({});
    const [backpackInfo, setBackpackInfo] = useState({
        itembox: 'Bag',
        max_capacity: 20,
        used_slots: 0,
        available_slots: 20
    });

    useEffect(() => {
        fetchItems();
    }, [activeTab]);

    const fetchItems = async () => {
        try {
            setLoading(true);
            
            // Use the new getBackpackItems API that categorizes by markt table
            const response = await axiosInstance.get(`${API_ENDPOINTS.GET_BACKPACK_ITEMS}?category=${activeTab}`);
            
            if (response.data && response.data.success) {
                const items = response.data.items || [];
                
                // Map items to the format expected by the UI
                const formattedItems = items.map(item => ({
                    naam: item.naam,
                    amount: item.amount,
                    unit_value_silver: item.unit_value_silver || 0,
                    unit_value_gold: item.unit_value_gold || 0,
                    soort: item.soort
                }));
                
                setItems(formattedItems);
                
                // Update backpack info
                if (response.data.backpack) {
                    setBackpackInfo(response.data.backpack);
                }
            } else {
                setItems([]);
            }
        } catch (error) {
            console.error('Error fetching items:', error);
            toast.error('Failed to load items');
            setItems([]);
        } finally {
            setLoading(false);
        }
    };

    const handleTabChange = (tab) => {
        setActiveTab(tab);
    };

    const handleSellAmountChange = (itemName, value) => {
        setSellAmounts(prev => ({
            ...prev,
            [itemName]: value
        }));
    };

    const handleSellItem = async (item) => {
        const amount = parseInt(sellAmounts[item.naam] || 0);
        
        if (amount <= 0) {
            toast.error(t('Please enter a valid amount'));
            return;
        }
        
        if (amount > item.amount) {
            toast.error(t('You do not have enough items'));
            return;
        }
        
        setSellingItems(prev => ({ ...prev, [item.naam]: true }));
        
        try {
            const response = await axiosInstance.post(API_ENDPOINTS.SELL_ITEM, {
                item_name: item.naam,
                amount: amount
            });
            
            if (response.data && response.data.success) {
                toast.success(response.data.message || t('Items sold successfully!'));
                setSellAmounts(prev => {
                    const newAmounts = { ...prev };
                    delete newAmounts[item.naam];
                    return newAmounts;
                });
                fetchItems(); // Refresh items
            } else {
                toast.error(response.data.error || t('Failed to sell items'));
            }
        } catch (error) {
            console.error('Error selling item:', error);
            toast.error(error.response?.data?.error || t('Failed to sell items'));
        } finally {
            setSellingItems(prev => ({ ...prev, [item.naam]: false }));
        }
    };

    const getItemImageName = (itemName) => {
        // Convert item name to image filename
        // Replace spaces with underscores and add .png extension
        return itemName.replace(/\s+/g, '_').trim() + '.png';
    };

    return (
        <div className="ar_mainBody" dir={isRTL ? 'rtl' : 'ltr'}>
            <GoldSiverHeader previous={'/home'} title={t('Backpack')}>
                {/* Header Section - Similar to Market */}
                <section className="ar_market_filter_section">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="ar_market_filter_title">
                                    <div className="ar_market_cover_image_wrapper">
                                        <img src="/images/cover/1.png" alt="Backpack Cover" className="ar_market_cover_image" />
                                    </div>
                                    <div className="ar_market_cover_overlay"></div>
                                    <div className="ar_market_cover_content">
                                        <h1>{t('Backpack')}</h1>
                                        
                                        <p>{t('Backpack Description')}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Tabs Section - Similar to Market */}
                <section className="ar_market_tabs_section">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="ar_market_tabs_area">
                                    <ul className="ar_market_tabs_list">
                                        <li className={activeTab === 'pokemon_balls' ? 'active' : ''}>
                                            <a href="#" onClick={(e) => { e.preventDefault(); handleTabChange('pokemon_balls'); }} data-tab="pokemon_balls">
                                                {t('Pokemon Balls')}
                                            </a>
                                        </li>
                                        <li className={activeTab === 'key_items' ? 'active' : ''}>
                                            <a href="#" onClick={(e) => { e.preventDefault(); handleTabChange('key_items'); }} data-tab="key_items">
                                                {t('Key Items')}
                                            </a>
                                        </li>
                                        <li className={activeTab === 'special_items' ? 'active' : ''}>
                                            <a href="#" onClick={(e) => { e.preventDefault(); handleTabChange('special_items'); }} data-tab="special_items">
                                                {t('Special Items')}
                                            </a>
                                        </li>
                                        <li className={activeTab === 'potions' ? 'active' : ''}>
                                            <a href="#" onClick={(e) => { e.preventDefault(); handleTabChange('potions'); }} data-tab="potions">
                                                {t('Potions')}
                                            </a>
                                        </li>
                                        <li className={activeTab === 'stones' ? 'active' : ''}>
                                            <a href="#" onClick={(e) => { e.preventDefault(); handleTabChange('stones'); }} data-tab="stones">
                                                {t('Stones')}
                                            </a>
                                        </li>
                                        <li className={activeTab === 'attacks' ? 'active' : ''}>
                                            <a href="#" onClick={(e) => { e.preventDefault(); handleTabChange('attacks'); }} data-tab="attacks">
                                                {t('TM\'S / HM\'S')}
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Items Table Section */}
                <section className="ar_market_table_section">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="ar_market_table_area">
                                    {/* Backpack Capacity Info */}
                                    <div className="ar_backpack_capacity_info" style={{ marginBottom: '20px', display: 'flex', gap: '20px', justifyContent: 'center', alignItems: 'center', flexWrap: 'wrap' }}>
                                        <div className="ar_backpack_capacity_item">
                                            <strong>{t('Backpack Capacity')}:</strong>
                                            <span style={{ marginLeft: '10px' }}>
                                                {backpackInfo.used_slots} / {backpackInfo.max_capacity}
                                            </span>
                                        </div>
                                        <div className="ar_backpack_capacity_item">
                                            <strong>{t('Available')}:</strong>
                                            <span style={{ marginLeft: '10px', color: backpackInfo.available_slots < 10 ? '#ff6b6b' : '#3c3c3c' }}>
                                                {backpackInfo.available_slots}
                                            </span>
                                        </div>
                                    </div>
                                    <div className="ar_market_table_wrapper">
                                        <table className="ar_market_table">
                                            <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th>{t('Item')}</th>
                                                    <th>{t('Amount')}</th>
                                                    <th>{t('Unit value')}</th>
                                                    <th>{t('Sell')}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {loading ? (
                                                    <tr>
                                                        <td colSpan="5" className="ar_market_no_data">{t('Loading...')}</td>
                                                    </tr>
                                                ) : items.length === 0 ? (
                                                    <tr>
                                                        <td colSpan="5" className="ar_market_no_data">{t('No items available in this category')}</td>
                                                    </tr>
                                                ) : (
                                                    items.map((item, index) => (
                                                        <tr key={item.naam} className="ar_market_table_row">
                                                            <td>{index + 1}</td>
                                                            <td>
                                                                <div className="ar_market_pokemon_cell">
                                                                    <img 
                                                                        src={`/images/items/${getItemImageName(item.naam)}`} 
                                                                        alt={item.naam} 
                                                                        className="ar_market_pokemon_img"
                                                                        onError={(e) => {
                                                                            e.target.src = '/images/items/default.png';
                                                                        }}
                                                                    />
                                                                    <div className="ar_market_pokemon_info">
                                                                        <span className="ar_market_pokemon_name">{item.naam}</span>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className="ar_market_power_cell">
                                                                    <strong>{item.amount}x</strong>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className="ar_market_price_cell">
                                                                    {item.unit_value_silver > 0 && (
                                                                        <>
                                                                            <img 
                                                                                src="/images/mock-05.png" 
                                                                                alt="silver" 
                                                                                className="ar_market_price_icon"
                                                                            />
                                                                            <strong>{item.unit_value_silver.toLocaleString()}</strong>
                                                                        </>
                                                                    )}
                                                                    {item.unit_value_gold > 0 && (
                                                                        <>
                                                                            <img 
                                                                                src="/images/mock-04.png" 
                                                                                alt="gold" 
                                                                                className="ar_market_price_icon"
                                                                            />
                                                                            <strong>{item.unit_value_gold.toLocaleString()}</strong>
                                                                        </>
                                                                    )}
                                                                    {item.unit_value_silver === 0 && item.unit_value_gold === 0 && (
                                                                        <span>{t('N/A')}</span>
                                                                    )}
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className="ar_market_action_buttons">
                                                                    <Form.Control
                                                                        type="number"
                                                                        min="1"
                                                                        max={item.amount}
                                                                        value={sellAmounts[item.naam] || ''}
                                                                        onChange={(e) => handleSellAmountChange(item.naam, e.target.value)}
                                                                        placeholder={t('Amount')}
                                                                        className="ar_backpack_sell_input"
                                                                        style={{ width: '100px', display: 'inline-block', marginRight: '10px' }}
                                                                    />
                                                                    <button
                                                                        className="ar_market_buy_btn"
                                                                        onClick={() => handleSellItem(item)}
                                                                        disabled={sellingItems[item.naam] || !sellAmounts[item.naam] || parseInt(sellAmounts[item.naam] || 0) <= 0}
                                                                    >
                                                                        {sellingItems[item.naam] ? t('Selling...') : t('OK')}
                                                                    </button>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </GoldSiverHeader>
        </div>
    );
}

export default Backpack;
